import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChildFn,
    CanActivateFn,
    Router,
    UrlTree,
} from '@angular/router';
import { PermissionService } from '@core/permission/permission.service';
import { catchError, map, Observable, of } from 'rxjs';

function checkPermission(
    route: ActivatedRouteSnapshot
): boolean | Observable<boolean | UrlTree> {
    const router = inject(Router);
    const permissionsService = inject(PermissionService);
    const permissionRoute = getDeepestPermissionRoute(route);

    const permission = permissionRoute?.data?.['permission'] as
        | string
        | undefined;
    const permissions = permissionRoute?.data?.['permissions'] as
        | string[]
        | undefined;

    if (!permission && !permissions?.length) {
        return true;
    }

    return permissionsService.ensureAuthorizationContextLoaded().pipe(
        map(() => {
            const allowed = permission
                ? permissionsService.has(permission)
                : permissionsService.hasAny(permissions ?? []);

            return allowed ? true : router.parseUrl('/dashboard');
        }),
        catchError(() => of(router.parseUrl('/dashboard')))
    );
}

function getDeepestPermissionRoute(
    route: ActivatedRouteSnapshot
): ActivatedRouteSnapshot | null {
    let current: ActivatedRouteSnapshot | null = route;
    let permissionRoute: ActivatedRouteSnapshot | null = null;

    while (current) {
        if (
            current.data?.['permission'] ||
            current.data?.['permissions']?.length
        ) {
            permissionRoute = current;
        }

        current = current.firstChild;
    }

    return permissionRoute;
}

export const PermissionGuard: CanActivateFn = (route) => checkPermission(route);

export const PermissionsChildGuard: CanActivateChildFn = (childRoute) =>
    checkPermission(childRoute);
